<template>
    <div>
        <!-- Custom backdrop for nested modal -->
        <div id="nestedModalBackdrop" class="nested-modal-backdrop" v-show="isModalVisible" @click="closeModal"></div>

        <div class="modal attendance-modal fade" id="addAttachmentToConversationModal" tabindex="-1"
            aria-labelledby="addAttachmentToConversationModal" aria-hidden="true" style="z-index:99999;">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header rounded-bottom-0 py-3 px-4 bg-primary">
                        <div>
                            <p class="text-lg mb-0 fw-semibold">Bijlage toevoegen/verwijderen</p>
                        </div>
                        <button @click="closeModal()" type="button" class="btn-close mb-0 me-0"></button>
                    </div>
                    <div class="modal-body pt-3 pb-4 px-4">
                        <div class="row" style="margin-bottom: 15px;">
                            <div class="col-md-8">
                            <span class="btn btn-sm btn-success fileinput-button" style="margin-right: 10px;">
                                <i class="fa fa-plus"></i>
                                <span>Voeg bestanden toe</span>
                            </span>
                        </div>
                            <div class="col-md-4">
                                <div class="fileupload-process">
                                    <div id="total-progress-conversation" class="progress progress-striped active"
                                         role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
                                        <div class="progress-bar progress-bar-success" style="width:0%;"
                                             data-dz-uploadprogress>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="table table-striped files" id="previews-conversation">
                            <div id="dropzone-template-conversation" class="file-row">
                                <div style="width: 50%;">
                                    <p class="name"><i class="fa fa-file-o"></i>
                                        <span data-dz-name></span> (<span data-dz-size></span>)</p>
                                    <strong class="error text-danger" data-dz-errormessage></strong>
                                </div>
                                <div>
                                    <div class="progress progress-striped active" role="progressbar" aria-valuemin="0"
                                         aria-valuemax="100" aria-valuenow="0">
                                        <div class="progress-bar progress-bar-success" style="width:0%;"
                                             data-dz-uploadprogress></div>
                                    </div>
                                </div>
                                <div>
                                    <button data-dz-remove class="btn btn-xs btn-warning cancel">
                                        <i class="fa fa-ban"></i>
                                        <span>Cancel</span>
                                    </button>
                                    <button data-dz-remove class="btn btn-sm btn-danger delete">
                                        <i class="fa fa-trash-o"></i>
                                        <span>Delete</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div class="content-wrapper mt-4">
                            <div v-if="attachments && attachments.length > 0">
                                <div class="form-title">
                                    <h5>Reeds toegevoegde bijlagen</h5>
                                    <hr/>
                                </div>
                                <ul id="attachments-list" class="list-group">
                                    <li v-for="attachment in attachments" :key="attachment.id"
                                        class="list-group-item attachment">
                                        <i class="fa fa-file-o"></i>
                                        <a :href="attachment.downloadUrl" target="_blank">
                                        <span v-if="attachment.meta && attachment.meta.title" class="title">
                                            {{
                                                attachment.meta.title
                                            }} <small>(<em>{{
                                                attachment.meta.filename || attachment.name
                                            }}</em>)</small>
                                        </span>
                                            <span v-else class="title">{{
                                                    attachment.meta && attachment.meta.filename ? attachment.meta.filename : attachment.name
                                                }}</span>
                                        </a>
                                        <div v-if="canDeleteAttachments" class="action pull-right">
                                            <button @click.stop.prevent="deleteAttachment(attachment.id)"
                                                    class="btn btn-danger btn-xs" style="color:#fff;" type="button">
                                                <i class="fa fa-trash-o"></i>
                                            </button>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div v-else>Geen bijlagen gevonden</div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import {EventBus} from "../../../event-bus";

export default {
    name: 'add-attachment-to-conversation-modal',
    data() {
        return {
            attachments: [],
            conversationId: null,
            currentUserId: null,
            entityId: null,
            attachmentType: 'conversation-attachments',
            canDeleteAttachments: true,
            dropzone: null,
            modal: null,
            dropzoneTemplate: null,
            dropzonePreviewTemplate: null,
            isModalVisible: false
        }
    },
    methods: {
        initDropzone() {
            // Destroy existing dropzone if it exists
            if (this.dropzone) {
                this.dropzone.destroy();
                this.dropzone = null;
            }

            const previewWrapper = document.getElementById('previews-conversation');
            if (!previewWrapper) {
                console.error('Preview wrapper not found');
                return;
            }

            // Store template on first run including the outer HTML
            if (!this.dropzoneTemplate) {
                const previewNode = document.getElementById('dropzone-template-conversation');
                if (!previewNode) {
                    console.error('Template node not found');
                    return;
                }
                // Store the full outer HTML of the template (including the file-row div wrapper)
                this.dropzoneTemplate = previewNode.outerHTML;
                // For Dropzone preview, create a version without the ID to avoid duplicates
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = previewNode.outerHTML;
                const clonedNode = tempDiv.firstChild;
                clonedNode.removeAttribute('id');
                this.dropzonePreviewTemplate = clonedNode.outerHTML;
            }

            // Remove all children except the template, or restore template if missing
            const templateNode = document.getElementById('dropzone-template-conversation');
            if (!templateNode) {
                // Template was removed, restore it
                previewWrapper.innerHTML = this.dropzoneTemplate;
            } else {
                // Remove all file previews but keep the template
                Array.from(previewWrapper.children).forEach(child => {
                    if (child.id !== 'dropzone-template-conversation') {
                        child.remove();
                    }
                });
            }

            previewWrapper.style.display = 'none';

            // Initialize Dropzone with autoDiscover disabled
            window.Dropzone.autoDiscover = false;

            // Use entityId and attachmentType if available (linked entity), otherwise use conversationId
            const uploadId = this.entityId || this.conversationId;
            const uploadType = this.attachmentType;

            this.dropzone = new window.Dropzone('#addAttachmentToConversationModal .modal-body', {
                url: `../media/upload/${uploadId}/${uploadType}`,
                parallelUploads: 20,
                createImageThumbnails: false,
                previewTemplate: this.dropzonePreviewTemplate,
                autoQueue: true,
                previewsContainer: "#previews-conversation",
                clickable: ".fileinput-button"
            });

            this.dropzone.on("addedfile", (file) => {
                previewWrapper.style.display = 'table';
            });

            this.dropzone.on("totaluploadprogress", (progress) => {
                document.querySelector("#total-progress-conversation .progress-bar").style.width = progress + "%";
            });

            this.dropzone.on("sending", (file) => {
                document.querySelector("#total-progress-conversation").style.opacity = "1";
            });

            this.dropzone.on("queuecomplete", (progress) => {
                document.querySelector("#total-progress-conversation").style.opacity = "0";
                // Refresh the attachments list to show newly uploaded files
                setTimeout(() => {
                    this.refreshAttachments();
                }, 500);
            });

            this.dropzone.on("success", (file, response) => {
                // Remove the file preview after successful upload
                this.dropzone.removeFile(file);
            });

            this.dropzone.on("error", (file, errorMessage) => {
                this.$swal("Er is een fout opgetreden", errorMessage, "error");
            });
        },
        refreshAttachments() {
            axios.get('api/add-attachment-to-conversation/' + this.conversationId)
                .then(response => {
                    if (response.data.status === 422) {
                        throw [true, response.data.message];
                    }
                    this.attachments = response.data.attachments || [];
                    this.canDeleteAttachments = response.data.canDeleteAttachments !== false;

                    // Also refresh the conversation to update attachment count
                    axios.get('api/get-conversation-messages/' + this.conversationId)
                        .then(response => {
                            if (response.data && response.data.id) {
                                EventBus.$emit('conversationSelected', response.data);
                            }
                        });
                })
                .catch(e => {
                    this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de bijlagen.", "error");
                });
        },
        deleteAttachment(attachmentId) {
            this.$swal({
                title: "Bijlage verwijderen. Weet je het zeker?",
                text: "Deze actie kan niet ongedaan gemaakt worden.",
                showCancelButton: true,
                cancelButtonColor: "#3EBE00",
                confirmButtonColor: "#DD3444",
                confirmButtonText: "Ja, nu verwijderen",
                cancelButtonText: "Annuleren",
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.post('api/delete-conversation-attachment', {
                        attachmentId: attachmentId,
                        conversationId: this.conversationId
                    })
                        .then(response => {
                            if (response.data.status === 422) {
                                throw [true, response.data.message];
                            }
                            this.refreshAttachments();
                        })
                        .catch(e => {
                            this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het verwijderen van de bijlage.", "error");
                        });
                }
            });
        },
        closeModal() {
            // Hide custom backdrop
            this.isModalVisible = false;

            // Cleanup dropzone before closing
            if (this.dropzone) {
                this.dropzone.destroy();
                this.dropzone = null;
            }

            // Refresh the conversation to update attachment count
            if (this.conversationId) {
                axios.get('api/get-conversation-messages/' + this.conversationId)
                    .then(response => {
                        if (response.data && response.data.id) {
                            EventBus.$emit('conversationSelected', response.data);
                        }
                    });
            }
            EventBus.$emit('refetchConversations');
            this.modal.hide();
        }
    },
    mounted() {
        // Create modal without Bootstrap backdrop (we use our custom one)
        this.modal = new bootstrap.Modal(document.getElementById('addAttachmentToConversationModal'), {
            backdrop: false
        });

        const modalElement = document.getElementById('addAttachmentToConversationModal');

        // Show custom backdrop when modal is shown
        modalElement.addEventListener('show.bs.modal', () => {
            this.isModalVisible = true;
        });

        // Initialize Dropzone when modal is fully shown
        modalElement.addEventListener('shown.bs.modal', () => {
            // Use setTimeout to ensure DOM is fully rendered
            setTimeout(() => {
                this.initDropzone();
            }, 100);
        });

        // Cleanup on modal hide
        modalElement.addEventListener('hidden.bs.modal', () => {
            this.isModalVisible = false;
            if (this.dropzone) {
                this.dropzone.destroy();
                this.dropzone = null;
            }
        });

        EventBus.$on('addAttachmentToConversation', (data) => {
            this.attachments = data.attachments || [];
            this.conversationId = data.conversationId;
            this.currentUserId = data.currentUserId;
            this.entityId = data.entityId || null;
            this.attachmentType = data.attachmentType || 'conversation-attachments';
            this.canDeleteAttachments = data.canDeleteAttachments !== false;
            this.modal.show();
        });
    },
}
</script>

<style scoped>

/* Custom backdrop for nested modal */
.nested-modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 99998;
    animation: fadeIn 0.15s ease-in;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.table > :not(caption) > * > * {
    background-color: transparent !important;
}

.file-row {
    display: table-row;
    padding: 10px;
    border-bottom: 1px solid #ddd;
    background-color: transparent !important;
}

.file-row > div {
    display: table-cell;
    padding: 10px;
    vertical-align: middle;
    background-color: transparent !important;
}

#previews-conversation {
    display: none;
    margin-top: 15px;
    background-color: transparent !important;
}

/* Hide the template itself - only show actual file previews */
#dropzone-template-conversation {
    display: none !important;
}

.fileinput-button {
    cursor: pointer;
}

.progress {
    margin-bottom: 0;
}

#total-progress-conversation {
    opacity: 0;
    transition: opacity 0.3s linear;
}

.attachment .action {
    float: right;
}

#dashboard-modals .btn, #dashboard-modals .btn span {
    color: #fff !important;
}
</style>

<style>
/* Ensure SweetAlert appears above the attachment modal */
.swal2-container {
    z-index: 999999 !important;
}
</style>
